/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import type { UniqueIdentifier } from '@dnd-kit/core';
import { AnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CSSProperties } from 'react';

// import { iOS } from '../../utilities';
import { TreeItem, Props as TreeItemProps } from './TreeItem';

interface Props extends TreeItemProps {
  id: UniqueIdentifier;
  disabled?: boolean | undefined;
  isTarget?: boolean | undefined;
}

const animateLayoutChanges: AnimateLayoutChanges = ({ isSorting, wasDragging }) =>
  !(isSorting || wasDragging);

export function SortableTreeItem({ id, depth, disabled = false, isTarget = false, ...props }: Props) {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setDraggableNodeRef,
    setDroppableNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    animateLayoutChanges,
    disabled,
  });
  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <TreeItem
      ref={setDraggableNodeRef}
      wrapperRef={setDroppableNodeRef}
      style={style}
      depth={depth}
      ghost={isDragging}
      // disableSelection={iOS}
      disableInteraction={isSorting}
      disabled={disabled}
      isTarget={isTarget}
      handleProps={{
        ...attributes,
        ...listeners,
      }}
      {...props}
    />
  );
}

SortableTreeItem.defaultProps = {
  disabled: undefined,
  isTarget: undefined,
};